// reducers/loginUserInfoReducer.ts
import {ClassInfo, LoginResponse, provinceInfo, UserInfo} from "../../type/type";
import DefaultProfileS from '../../assets/image/common/default_profile_S.svg'

// 초기 상태 정의
const initialUserInfo = {
    access: {
        site_id_list: [],
        user_id: 0,
        user_role: '',
        access_token: '',
    },
    userMainImageUrl: DefaultProfileS,
    user: {
        id: 0,
        name: '',
        email: '',
        phone: '',
        role: '',
        approval: 0,
        login_id: '',
        temp_phone: '',
        user_site_list: [],
        company_id: 0,
        terms_agree: 0,
        unique_code: '',
        card_no: '',
        reg_date: '',
        update_date: null,
        approval_date: '',
        last_login_date: '',
        last_logout_date: '',
        mobile_os: 0,
        mobile_token: '',
        push_agree: 0,
        is_delete: 0,
        image_list: [],
        student_list: [],
        class_name_list: [],
        image_url: "",
        temp_class_name: "",
        resident_number: "",
        gender: 0,
    },
    selectSiteId: 0,
    userClassId: 0, //선생님이 담당하는 default class id
    classSelectOption:[] as provinceInfo[],
    teacherClassList: [] as ClassInfo[],
};

// 액션 타입
const SET_USER_INFO = 'SET_USER_INFO';
const SET_USER_MAIN_IMAGE_URL = 'SET_USER_MAIN_IMAGE_URL';
const SET_SELECT_SITE_ID = 'SET_SELECT_SITE_ID';
const SET_TEACHER_CLASS_LIST = 'SET_TEACHER_CLASS_LIST';
const SET_USER_LOGOUT = 'SET_USER_LOGOUT';



// 액션 생성자
export const setUserInfo = (access: LoginResponse, user: UserInfo, selectSiteId: number) => ({
    type: SET_USER_INFO,
    payload: { access, user, selectSiteId }
});

// 
export const setUserLogout = () => ({
    type: SET_USER_LOGOUT,
    payload: {}
});


export const setUserMainImageUrl = (imageUrl: string) => ({
    type: SET_USER_MAIN_IMAGE_URL,
    payload: imageUrl,
});

export const setSelectSiteId = (siteId: number) => ({
    type: SET_SELECT_SITE_ID,
    payload: siteId,
});

export const setTeacherClassList = (teacherClassList: ClassInfo[], userClassId:number, classSelectOption:provinceInfo[]) => ({
    type: SET_TEACHER_CLASS_LIST,
    payload: {teacherClassList, userClassId, classSelectOption}
});

// 리듀서
export const loginUserInfoReducer = (state = initialUserInfo, action: any) => {
    switch (action.type) {
        case SET_USER_INFO:
            return {
                ...state,
                access: action.payload.access,
                user: action.payload.user,
                selectSiteId: action.payload.selectSiteId,
            };
        case SET_USER_MAIN_IMAGE_URL:
            return { ...state, userMainImageUrl: action.payload };
        case SET_SELECT_SITE_ID:
            return { ...state, selectSiteId: action.payload };
        case SET_TEACHER_CLASS_LIST:
            return {
                ...state,
                teacherClassList: action.payload.teacherClassList,
                userClassId: action.payload.userClassId,
                classSelectOption: action.payload.classSelectOption
            };
        case SET_USER_LOGOUT:
            return initialUserInfo;
        
        default:
            return state;
    }
};
